import Setting from '@/views/Setting/Setting'

const module = [
  {
    path: 'settings',
    name: 'Setting',
    component: Setting
  }
];

export default module;


// WEBPACK FOOTER //
// ./src/router/modules/setting.js